import LegendItem from './LegendItem';

export default LegendItem;
